import { useState } from "react";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import { useBalanceWidgetData } from "../widgetHooks";
import BalanceWidgetListDialog from "./BalanceWidgetListDialog";
import TabularWidgetPreviewCard from "./TabularWidgetPreviewCard";

interface Props {
  widgetSettings: PortalWidget;
}

const BalanceWidgetPreviewCard = ({ widgetSettings }: Props) => {
  const [showFullWidget, setShowFullWidget] = useState(false);

  const { report, fetchError, noDataText } = useBalanceWidgetData(widgetSettings, {
    rowsLimit: 1,
  });

  return (
    <>
      <TabularWidgetPreviewCard
        widgetSettings={widgetSettings}
        report={report}
        columnsLimit={7}
        noDataText={noDataText}
        fetchError={fetchError}
        onViewAllClick={() => setShowFullWidget(true)}
      />

      {showFullWidget && (
        <BalanceWidgetListDialog widgetSettings={widgetSettings} onClose={() => setShowFullWidget(false)} />
      )}
    </>
  );
};

export default BalanceWidgetPreviewCard;
